import http from "@/request/index.ts";

export default class ProductApi {
  /**
   * 获取产品列表接口
   * @param {*} data {productsTitle?: string};
   */
  async getProductList(data) {
    let res = await http.get("/products/list", data);
    return res;
  }

  /**
   * 获取产品详情接口
   */
  async getProductDetail(params) {
    console.log('params---------',params)
    let res = await http.get("/products/" + params.id);
    return res;
  }

  /**
   * 产品浏览新增接口
   * @param {*} id
   */
  async addProductBrowse(id) {
    let res = await http.post(`/products/readNum/${id}`);
    return res;
  }

  /**
   * 设备列表接口
   */
  async getDeviceList() {
    let res = await http.get("/equipment/classifyList");
    return res;
  }

  /**
   * 设备详情接口
   */
  async getDeviceDetail(id) {
    let res = await http.get("/equipment/" + id);
    return res;
  }

  /**
   * 更多设备接口
   * 设备类型id
   * equipmentTypeId?: number;
   */
  async getMoreDevice(data) {
    let res = await http.get("/equipment/list", data);
    return res;
  }

  /**
   * 设备浏览新增接口
   * @param {*} id
   */
  async addDeviceBrowse(id) {
    let res = await http.post(`/equipment/readNum/${id}`);
    return res;
  }
}
